import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { MessageService } from '../../../../../core';
import { ClienteAnaliseFinanceira } from '../cliente-analise-financeira';
import { isClienteAnaliseFinanceiraStatusPendente, isClienteAnaliseFinanceiraStatusEmAnalise, isClienteAnaliseFinanceiraStatusConcluida } from '../status';

interface Config {
    isStatusPendente: boolean;
    isStatusEmAnalise: boolean;
    isStatusConcluida: boolean;
}

@Component({
    selector: 'sgt-cliente-analise-financeira-form',
    templateUrl: './cliente-analise-financeira-form.component.html',
    styleUrls: ['./cliente-analise-financeira-form.component.less']
})
export class ClienteAnaliseFinanceiraFormComponent implements OnChanges {
    config: Config;

    @Input() cliente: ClienteAnaliseFinanceira;
    @Input() canEdit = true;
    @Input() showCliente = true;
    @Input() showRepresentante = true;

    @ViewChild('form') form: NgForm;
    @ViewChild('textAreaAnotacao') textAreaAnotacao: ElementRef;

    constructor(private messageService: MessageService) { }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'cliente') {
                this.setConfig();
            }
        }
    }


    private setConfig() {
        this.config = {
            isStatusPendente: isClienteAnaliseFinanceiraStatusPendente(this.cliente?.statusAnaliseFinanceira) ?? false,
            isStatusEmAnalise: isClienteAnaliseFinanceiraStatusEmAnalise(this.cliente?.statusAnaliseFinanceira) ?? false,
            isStatusConcluida: isClienteAnaliseFinanceiraStatusConcluida(this.cliente?.statusAnaliseFinanceira) ?? false,
        }
    }

    /** Seta o foco no campo da anotação */
    setFocusAnotacao() {
        jQuery(this.textAreaAnotacao.nativeElement).trigger('focus');
    }

    /** Verifica se o form da análise financeira do cliente está válido */
    isValid(): boolean {
        if (this.canEdit) {
            // Anotação
            if (!this.cliente.anotacaoAnaliseFinanceira || this.cliente.anotacaoAnaliseFinanceira.trim().length < 15) {
                this.messageService.warning('A anotação da análise financeira deve ter no mínimo 15 caracteres', 'Atenção');
                this.setFocusAnotacao();
                return false;
            }

            return this.form.valid;
        }
        return true;
    }
}
